import { FormGroup } from '@angular/forms';
import { TypedFormData } from '@src/app/model/typed-form-data';

export class GroupedFormData {
  formGroup: FormGroup;
  typedFormData: (TypedFormData<any[]> | TypedFormData<boolean> | TypedFormData<number> | TypedFormData<object>
    | TypedFormData<string>)[];

  subject: JSON;

  constructor(
    formGroup: FormGroup,
    typedFormData: (TypedFormData<any[]> | TypedFormData<boolean> | TypedFormData<number> | TypedFormData<object>
      | TypedFormData<string>)[],
    subject: JSON
  ) {
    this.formGroup = formGroup;
    this.typedFormData = typedFormData;
    this.subject = subject;
  }
}
